const onMessage = function (cb) {
  window.addEventListener('message', function (e) {
    cb(e.data)
  })
}
const sendMessage = function (target, targetOrigin, data) {
  target.postMessage(data, targetOrigin)
}

export { onMessage, sendMessage }
